<template>
  <v-content
    :style="{
  'padding-top': 0,
  'padding-left': 0,
  'padding-right': 0,
  'padding-bottom':$vuetify.breakpoint.smAndUp? 0: '64px'}"
  >
    <v-container fluid mx-0 px-0 mt-0 pt-0>
      <v-layout wrap>
        <v-flex xs12 d-flex>
          <v-tabs class="tabs" fixed grow v-model="selectedTab">
            <v-tab href="#public" ripple>
              <img src="/static/images/magic-link-dark.svg" width="22" alt="Magic Link Icon" />
              <v-spacer style="max-width: 6px"></v-spacer>
              <span>{{$tf('Magic Link')}}</span>
            </v-tab>
            <!--<hr class="accent" style="width: 1px; height: 50px; border: none;" />-->
            <v-tab href="#private" ripple>
              <v-icon>group</v-icon>
              <v-spacer style="max-width: 6px"></v-spacer>
              {{$tf('Private share')}}
            </v-tab>
            <v-tab href="#export" ripple v-if="canDownload">
              <v-icon>import_export</v-icon>
              <v-spacer style="max-width: 6px"></v-spacer>
              {{$tf('Export options')}}
            </v-tab>
          </v-tabs>
        </v-flex>
        <v-flex xs12 pa-3 d-flex>
          <v-tabs-items v-model="selectedTab">
            <v-tab-item class="tab-body" id="public">
              <share-magic-link-card
                class="my-3"
                :flat="file.type !== 'container_dicom ' && !sharableThroughWhatsApp"
                :file="file"
                :loading="loading"
                :shared-with="sharedWith"
                @set-shared-with="setSharedWith"
              ></share-magic-link-card>
            </v-tab-item>
            <v-tab-item class="tab-body" id="private">
              <share-private
                :file="file"
                :shared-with="sharedWith"
                @set-shared-with="setSharedWith"/>

            </v-tab-item>
            <v-tab-item class="tab-body" id="export" v-if="canDownload">
              <share-whats-app-card
                :file="file"
                ></share-whats-app-card>
              <share-video-card
                :disabled="file.type !== 'container_dicom'"
                class="mb-3"
                :file="file"
                :exists="videoExists"
                :video-id="videoId"
              ></share-video-card>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import ShareMagicLinkCard from '~/components/common/share/ShareMagicLinkCard.vue'
import ShareVideoCard from '~/components/common/share/ShareVideoCard.vue'
import SharePrivate from '~/components/common/share/SharePrivate.vue'
import { onMounted, onUnmounted } from '@vue/composition-api'
import { useEventHelper } from '~/helpers/eventHelper'
import { useBackEvents } from '~/commons/events'
import MainBus from '~/bus'
import ShareWhatsAppCard from '~/components/common/share/ShareWhatsAppCard.vue'
import { useWhatsApp } from '~/commons/whatsapp'
import Api from '~/store/idonia-api/api'
import { useBusUtils } from '~/commons/busUtils'

const { BusHandlerManager } = useBusUtils()
export default {
  name: 'DialogNewShareFile',
  components: {
    ShareWhatsAppCard,
    SharePrivate,
    ShareVideoCard,
    ShareMagicLinkCard
  },
  props: {
    file: {
      type: Object,
      required: true
    },
    videoExists: {
      type: Boolean,
      default: false
    },
    videoId: {
      type: Number,
      default: 0
    }
  },
  setup (props, { root: { $store, $tf } }) {
    const { subscribe } = useBackEvents()
    const {
      events,
      getEventContext,
      newHandler,
      getEventFile
    } = useEventHelper()
    const { allowedExtensions } = useWhatsApp($store, $tf)
    const unsubscribe = []
    onMounted(() => {
      getEventContext().then(function (context) {
        const updateFileHandler = newHandler(function (payload) {
          getEventFile(props.file.id_file)
            .then(response => {
              MainBus.$emit('checkSharePermission', response)
            })
            .catch(e => {
              MainBus.$emit('checkSharePermission', { permission: 'none' })
              console.error(e)
            })
        }, context)
        const shareHandler = newHandler(function (payload) {
          console.debug('DEBUG share_completed: ', context, payload)
          MainBus.$emit('updateSharedWith', payload.deprecated_file_id)
          MainBus.$emit('shareLoadedCompleted', payload.deprecated_file_id)
        }, context)
        const unshareHandler = newHandler(function (payload) {
          console.debug('DEBUG unshare_completed: ', context, payload)
          MainBus.$emit('updateSharedWith', payload.deprecated_file_id)
          MainBus.$emit('unshareLoadedCompleted', payload.deprecated_file_id)
        }, context)
        unsubscribe.push(subscribe(
          events.shared,
          context.channels,
          shareHandler
        ))
        unsubscribe.push(subscribe(
          events.unshared,
          context.channels,
          unshareHandler
        ))
        unsubscribe.push(subscribe(
          [events.shared, events.unshared, events.moved, events.transferred],
          context.channels,
          updateFileHandler
        ))
      })
    })
    onUnmounted(() => {
      unsubscribe.forEach(unsub => unsub())
    })
    return {
      allowedExtensions
    }
  },
  data () {
    return {
      selectedTab: 'public',
      loading: false,
      bhm: new BusHandlerManager(),
      sharedWith: {}
    }
  },
  created () {
    window.addEventListener('resize', () => {
      this.$forceUpdate()
    })
    this.updateSharedWith(this.file.id_file)
    this.bhm.addHandler(MainBus, 'updateSharedWith', () => {
      this.updateSharedWith(this.file.id_file)
    })
    this.bhm.addHandler(MainBus, 'checkSharePermission', file => {
      if (file.permission !== 'all' && file.permission !== 'owner') {
        this.$store.dispatch('dialog/closeDialog')
        this.$store.dispatch('dialog/showDialog', {
          title: this.$tf('NoPermissionToShareTitle'),
          body: this.$tf('NoPermissionToShare'),
          persistent: false,
          width: 480,
          actions: {
            accept: {
              title: 'Close'
            }
          }
        })
      }
    })
  },
  destroyed () {
    this.bhm.cleanAll()
  },
  computed: {
    canDownload () {
      return !this.$whitelabel.downloadDisabled
    },
    sharableThroughWhatsApp () {
      return (
        this.file.type === 'document' &&
        this.allowedExtensions.includes(this.file.extension.toLowerCase()) &&
        this.$store.state.config.whatsappFiles
      )
    },
    fileType () {
      switch (this.file.type) {
        case 'directory':
          return this.$tf('this directory')
        case 'document':
        case 'document_vault':
          return this.$tf('this file')
        case 'container_dicom':
        case 'dicom_vault':
          return this.$tf('medical images')
        default:
          return this.$tf(this.file.type)
      }
    },
    fileID () {
      return parseInt(this.file.id_file)
    },
    selectedEmails () {
      return this.selected.map(item => item.email)
    },
    accountOwner () {
      return this.file && this.file.account_owner
        ? this.file.account_owner
        : {}
    }
  },
  methods: {
    setSharedWith (sharedWith) {
      this.sharedWith = sharedWith
    },
    updateSharedWith (fileID) {
      let id = this.fileID || fileID
      if (id) {
        this.loading = true
        Api.getV2(`file/${id}/shared`)
          .then(response => {
            if (response.body) {
              response.body['accounts'] = (response.body['accounts'] || [])
              response.body['groups'] = (response.body['groups'] || [])
              response.body['guests'] = (response.body['guests'] || [])
              const groups = response.body['groups']
              const guests = response.body['guests']
              const accounts = response.body['accounts'].filter(
                  item =>
                    item.account_id !== this.$store.state.session.account.account_id
                )
                .map(item => ({
                  ...item,
                  shareType: 'account'
                }))
              this.sharedWith = {}
              this.sharedWith['accounts'] = accounts
              this.sharedWith['groups'] = groups
              this.sharedWith['guests'] = guests
              this.sharedWith['organizations'] = response.body['organizations']
              this.sharedWith['public_url'] = response.body['public_url']
              this.sharedWith['subscription'] = response.body['has_subscription']
              this.sharedWith['privateShared'] = response.body['accounts'].length > 0 || groups.length > 0 || guests.length > 0
            } else {
              console.warn('Error getting shared with:\n', response)
            }
            this.loading = false
          })
          .catch(e => {
            console.error(e)
            this.loading = false
          })
      }
    }
  }
}
</script>

<style scoped>
</style>
<style>
.shareDialogCardText {
  overflow: auto !important;
  overflow-x: hidden !important;
}
.tabs {
  border-bottom: 1px solid rgb(202, 202, 202);
}
.tab-body {
  min-height: 360px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogNewShareFile.vue